import React from "react";
import { AudioPlayerContext } from "../..";
export default (function () {
    var player = React.useContext(AudioPlayerContext.Context);
    return player;
});
//# sourceMappingURL=useAudioPlayer.js.map